import { useMemo } from 'react';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { ProjectDto } from '@/core';

export type FormValueType = {
  name: string;
  positionId: string | null;
  department: string | null;
};

export const useSchemaEmployee = (projectData: ProjectDto, initialValue: FormValueType) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'projects.constructor' });
  const existingEmployees = projectData.employees
    .map((employee) => employee.name?.toLocaleLowerCase())
    .filter((employee) => employee !== initialValue?.name?.toLocaleLowerCase());

  return useMemo(
    () =>
      Yup.object().shape({
        name: Yup.string()
          .nullable()
          .required()
          .lowercase()
          .notOneOf(existingEmployees, t('addEmployees.employee.existing'))
          .max(250),
        positionId: Yup.string().nullable().required(),
        department: Yup.string().nullable().required(),
      }),
    [t, existingEmployees],
  );
};
